module.exports = __webpack_public_path__ + "img/clothing120.556caea8.jpg";